import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/UserWelcome.css";
import "./Styles/UserWelcomeSurveyResults.css";
import "./Styles/UserWelcomeIntro.css";
import NavBar from '../NavBar';
import CalculatorHabits from './Components/CalculatorPages/CalculatorHabits';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function CalculatorHabitsRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileHabitsRoutePage">
                    <div className="UserProfileHabitsRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="CalculatorHabitsRouteBlock">
                        <CalculatorHabits/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default CalculatorHabitsRoute;